import React, { useCallback, useEffect, useState } from "react";

import { Typography } from "antd";

interface InlineEditableTextInputProps {
  categoryName: string;
  text: string;
  canShowModal?: boolean;
  onTextChange: (_e: React.ChangeEvent<HTMLInputElement>, _categoryName: string) => void;
  onEditToggle: (_categoryName: string, _isEditing: boolean) => void;
  editIcon: string;
  style?: React.CSSProperties;
}

const InlineEditableTextInput: React.FC<InlineEditableTextInputProps> = ({
    categoryName,
    text,
    onTextChange,
    onEditToggle,
    editIcon,
    style,
}) => {
    const [isEditing, setIsEditing] = useState(false);
    const [currentText, setCurrentText] = useState(text);
    const [originalText, setOriginalText] = useState(text);

    const handleBlur = useCallback(() => {
        setIsEditing(false);
        onEditToggle(categoryName, false);
        if (!currentText.trim()) {
            setCurrentText(originalText);
        }
    }, [categoryName, currentText, originalText, onEditToggle]);

    const handleEditClick = () => {
        setIsEditing(true);
        setOriginalText(currentText);
        setCurrentText("");
        onEditToggle(categoryName, true);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCurrentText(e.target.value);
        onTextChange(e, categoryName);
    };
    const handleKeyDown = useCallback(
        (e: any) => {
            if (e.key === "Enter") {
                handleBlur();
            }
        },
        [handleBlur]
    );

    useEffect(() => {
        setCurrentText(text);
        setOriginalText(text);
    }, [text]);

    return (
        <div className={"new-questionnaire__amount-card-wrapper"} style={style} >
            <div
                className="new-questionnaire__income-card-total-text"
                style={{ fontSize: "14px", width: "60%" }}
                onClick={() => handleEditClick()}
            >
                {categoryName}
            </div>
            {isEditing ? (
                <div className="new-questionnaire__amount-question-input-wrapper">
                    <input
                        className="new-questionnaire__edit-expense-input mr5"
                        onChange={handleChange}
                        type="text"
                        autoFocus={true}
                        value={currentText}
                        onKeyDown={handleKeyDown}
                        onBlur={handleBlur}
                    />
                </div>
            ) : (
                <div className="horizontal-right" onClick={handleEditClick}>
                    {currentText === "" ? (
                        <div className="horizontal-center gap6">
                            <img src={editIcon} alt="edit" />
                            <div className="new-questionnaire__income-card-total-amount">
                                {"Add"}
                            </div>
                        </div>
                    )
                        : (<div className="horizontal-center gap6">
                            <img src={editIcon} alt="edit" />
                            <Typography className="new-questionnaire__income-card-total-amount">
                                {currentText || ""}
                            </Typography>
                        </div>)}
                </div>
            )}
        </div>
    );
};

export default InlineEditableTextInput;
